import React from "react";
import { useState, useEffect, useRef } from "react";

import { useAuth } from "../Auth/store";
import { useStationFilter } from "./store";

import Ref from '../../helpers/Reference';

import { Popover, Space, Button, Dropdown, Checkbox, Radio } from 'antd';
import { Button as CustomButton } from "../Buttons/button";

import { loadAreas, parseAreas } from "./search.helper";

import IcoArea from '../../images/ico_area_filter.svg';
import IcoAreaActive from '../../images/ico_area_filter_active.svg';
import References from "../../helpers/Reference";

export const AreaStation = ({startPos}) => {
    
    const [ areas, setAreas ] = useState([]);

    const [ filter, setFilter ] = useState([]);
    const [ opened, setOpened ] = useState( false );
    
    const { permission } = useAuth();

    useEffect(() => {
        if (permission?.permissions?.can_view_actual_layer) {
            loadAreas()
            .then(data => {
                setAreas( parseAreas(data) );
            });
        }
    }, 
    []);

    const StationFilter = ( filter ) => {
        useStationFilter.setState({areas: [...filter]});
    }

    const getChildrens = ( areas, val ) => {
        const parent = areas.filter(area => area.uuid === val);
        let result = parent[0].children.map(children => children.uuid);
        result.push( val );
        return result;
    }

    const onCheckedParent = ( e ) => {
        const checked = e.target.checked;
        const val = e.target.value;

        let currFilter = filter;
        const childrens = getChildrens(areas, val); 

        currFilter = checked ? [...currFilter, ...childrens] : currFilter.filter(x => !childrens.includes(x));;
        setFilter( [...currFilter] );    
        StationFilter(currFilter);
    }

    const onCheckedChildren = ( e ) => {
        const checked = e.target.checked;
        const val = e.target.value;

        let currFilter = filter;

        if (checked)
            currFilter.push( val );
        else {
            let index = currFilter.indexOf( val );
            if (index > -1)
                currFilter.splice( index, 1);
        } 
        setFilter( [...currFilter] );    
        StationFilter(currFilter);
    }    

    const onAcceptClick = () => {
        setOpened(false);
    }

    const onOpenChange = (newOpened) => {
        setOpened(newOpened);
    };    

    const onFilterClearClick = () => {
        setFilter([]);
        StationFilter([]);
    }

    const onSelectAllClick = () => {
        let result = [];
        result = areas.map(val => {
            return [...getChildrens(areas, val.uuid)]
        }).flat();
        setFilter( result );
        StationFilter( result );
    }

    const areasContent = () => {
        let items = areas.map( area => {
            return (                
                <div key={`area_filter_panel_wrap_${area.uuid}`}>
                    <div key={`area_fitler_panel_${area.uuid}`} className="mt-1 pv-1 borderb-eee">
                        <Checkbox 
                            value={area.uuid} 
                            onChange={onCheckedParent}
                            checked={filter.indexOf(area.uuid) !== -1}
                        >{area.name}</Checkbox>
                        </div>
                    <div className="pl-2" key={`area_filter_children_panel${area.uuid}`}>
                    {area.children.map(children => 
                        <div className="mt-1 pv-1 borderb-eee" key={`area_fitler_panel_${children.uuid}`}
                            ><Checkbox 
                                value={children.uuid} 
                                onChange={onCheckedChildren}
                                checked={filter.indexOf(children.uuid) !== -1}    
                            >{children.name}</Checkbox>
                            </div>
                    )}                                    
                    </div>                
                </div>
            )            
        })

        return (
            <>
            <div className="pv-3">
                <span className="close" onClick={() => setOpened(false)}>&times;</span>
                <Space className="text-center">
                    <Button type="default" onClick={onSelectAllClick}>{Ref.dictionary.select_all}</Button>
                    <Button type="default" onClick={onFilterClearClick}>{Ref.dictionary.reset_all}</Button>                                
                </Space>
            </div>

            <div className="area-popup">
            {items}
            </div>
            </>            
        )
    }

    return (
        <div className="left-menu-items" style={{top: `${startPos + 120}px`}}>
        {permission?.permissions?.can_view_actual_layer &&
            <Popover 
            trigger="click"
            open={opened}
            onOpenChange={onOpenChange}
            placement="topRight"                   
            overlayClassName="popup-left-menu-padding"
            arrow={false}    
            content={areasContent} >
                <>
                <CustomButton
                id="filter_station_area_btn"
                type="circle"
                icon={filter.length > 0 ? IcoAreaActive : IcoArea}
                tooltip={{
                    title: References.dictionary.tooltips.button_filter_station_area
                }}
                size="md"                
                />
                </>
            </Popover>   
        }
        </div>
        );
}